
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import moment from 'moment';

import {classesApi} from '@/api';
import formHelper from '../../../js/classes/classes.helper';

Vue.prototype.moment = moment;
@Component({
    components: {}
})
export default class New_Class extends Vue {
    @Prop({default: ''}) classType?: string;
    @Prop({default: {}}) classEdit?: any;
    // 清空表单并关闭新建/编辑班级模态框
    @Emit('closeModal') private closeModal() {}
    // 刷新班级列表
    @Emit('refreshClassList') private refreshClassList() {}
    // 显示授课管理模态框
    @Emit('showClassAuthorize') private showClassAuthorize() {}
    //===================================data区域begin
    formClass: any = formHelper.formClass;
    formRulesClass: any = formHelper.formRulesClass;
    //学段、年级数据
    pageData: any = {
        learnSectionList: [],
        gradeList: [],
        periodGradeList: []
    };
    // 属性数据
    attributeData: any = [
        {
            value: '1',
            name: '行政班'
        },
        {
            value: '2',
            name: '兴趣班'
        }
    ];
    classInfo: any = {
        classId: '',
        className: ''
    };
    //===================================data区域end
    //===================================computed区域begin
    isNewClass() {
        return this.classType === 'new';
    }
    //===================================computed区域end
    //===================================methods区域begin
    // 清空表单数据
    refreshForm() {
        this.formClass.name = '';
        this.formClass.period = undefined;
        this.formClass.grade = undefined;
        this.formClass.attribute = undefined;
    }
    handleCancel() {
        this.refreshForm();
        this.$emit('closeModal');
    }
    periodChange(value: string) {
        this.pageData.periodGradeList = [];
        if (this.classType != 'edit') {
            this.formClass.grade = undefined;
        }
        this.formClass.period = value;
        let period = '6';
        if (value == 'primary') {
            period = '1';
        } else if (value == 'junior') {
            period = '2';
        } else if (value == 'senior') {
            period = '3';
        } else if (value == 'vocational') {
            period = '4';
        } else if (value == 'professional') {
            period = '5';
        }
        for (var i = 0; i < this.pageData.gradeList.length; i++) {
            if (this.pageData.gradeList[i].extend2 == period) {
                this.pageData.periodGradeList.push(this.pageData.gradeList[i]);
            }
        }
        // console.log(this.pageData.periodGradeList);
    }
    gradeChange(value: string) {
        this.formClass.grade = value;
    }
    attributeChange(value: string) {
        this.formClass.attribute = value;
    }
    handleSave(flag: any) {
        // console.log(flag);
        // console.log(this.formClass);
        let me = this;
        let DataForm = {
            name: me.formClass.name,
            period: me.formClass.period,
            grade: me.formClass.grade,
            attribute: Number(me.formClass.attribute),
            schoolId: me.formClass.schoolId,
            _id: me.formClass._id
        };

        (this.$refs.classForm as any).validate((valid: any) => {
            if (!!valid === false) {
                console.log('error...........');
                return;
            }
            classesApi.saveClasses({
                context: me,
                data: DataForm,
                success(data: any, parameters: any) {
                    me.$message.success('操作成功');
                    if (flag == 'authorize') {
                        me.classInfo.classId = data.data._id;
                        me.classInfo.className = data.data.name;
                        me.$emit('showClassAuthorize');
                    }

                    me.$emit('refreshClassList');
                    me.handleCancel();
                },
                error(error: any, message: string, parameters: any) {
                    me.$message.error(message);
                }
            });
        });
    }
    //===================================methods区域end
    created() {
        // console.log(this);
        let schoolInfo: any = JSON.parse(window.localStorage.getItem('schoolInfo') as string);
        if (schoolInfo) {
            // console.log(schoolInfo);
            this.formClass.schoolId = schoolInfo._id;
        }
        if (this.classType == 'edit') {
            // console.log(this.classEdit);
            let classList = this.classEdit;
            this.formClass.name = classList.name;
            this.formClass.period = classList.period;
            this.formClass.grade = classList.grade;
            this.formClass.attribute = classList.attribute.toString();
            this.formClass._id = classList._id;
        } else {
            this.formClass.name = '';
            this.formClass.period = undefined;
            this.formClass.grade = undefined;
            this.formClass.attribute = undefined;
            this.formClass._id = '';
        }
        let me = this;
        this.$pageHelper.loadCodes({
            context: me,
            multipleCodeStr: 'learning_section,grade_level',
            success(codesJson: any) {
                me.$pageHelper.initPageDataItem(me.pageData.learnSectionList, codesJson, 'learning_section', false);
                me.$pageHelper.initPageDataItem(me.pageData.gradeList, codesJson, 'grade_level', true);
                if (me.classType == 'edit') {
                    me.periodChange(me.formClass.period);
                }
            }
        });
    }
    mounted() {}
}
